import "./offer-main-info.scss";

import React from "react";
import classNames from "classnames";

const OfferMainInfo = ({
	label,
	info,
	secondLabel,
	secondInfo,
	thirdInfo,
	thirdLabel,
	divider,
	choice,
	iconText,
	prefix,
	sufix,
	secondSufix,
}) => {
	return (
		<div
			className={classNames(`offer-main-info`, {
				[`offer-main-info--choice`]: choice,
			})}
		>
			<div className="offer-main-info__content offer-main-info__content--1">
				<div className="offer-main-info__label">{label}:</div>
				{prefix && (
					<div className="offer-main-info__prefix">{prefix}</div>
				)}
				{!choice && <div className="offer-main-info__info">{info}</div>}
				{sufix && <div className="offer-main-info__sufix">{sufix}</div>}
				{iconText && (
					<div className="offer-main-info__tooltip-container">
						<img
							src={require("assets/icons/tooltip.svg").default}
							className="offer-main-info__tooltip-icon"
							alt=""
						/>
						<div className="offer-main-info__tooltip-text">
							{iconText}
						</div>
					</div>
				)}
			</div>
			{secondInfo && (
				<div className="offer-main-info__content offer-main-info__content--2">
					{divider && (
						<div className="offer-main-info__divider">
							{divider}
						</div>
					)}
					{secondLabel && (
						<div className="offer-main-info__label">
							{secondLabel}:
						</div>
					)}
					{prefix && secondInfo && (
						<div className="offer-main-info__prefix">{prefix}</div>
					)}
					{secondInfo && (
						<div className="offer-main-info__info">
							{secondInfo}
						</div>
					)}
					{sufix && secondInfo && (
						<div className="offer-main-info__sufix">
							{secondSufix ? secondSufix : sufix}
						</div>
					)}
				</div>
			)}
			{thirdInfo && (
				<div className="offer-main-info__content offer-main-info__content--3">
					{thirdInfo && (
						<div className="offer-main-info__divider">
							{divider}
						</div>
					)}
					{thirdInfo && (
						<div className="offer-main-info__label">
							{thirdLabel}:
						</div>
					)}
					{prefix && thirdInfo && (
						<div className="offer-main-info__prefix">{prefix}</div>
					)}
					{thirdInfo && (
						<div className="offer-main-info__info">{thirdInfo}</div>
					)}
					{sufix && thirdInfo && (
						<div className="offer-main-info__sufix">{sufix}</div>
					)}
				</div>
			)}
			{choice && (
				<>
					<div
						className={classNames("offer-main-info__info", {
							[`offer-main-info__info--inactive`]: !info,
						})}
					>
						tak
					</div>
					<div
						className={classNames("offer-main-info__info", {
							[`offer-main-info__info--inactive`]: info,
						})}
					>
						nie
					</div>
				</>
			)}
		</div>
	);
};

export default OfferMainInfo;
